import React from 'react';

const Exit = ({ width = '1.2rem', height = '1.2rem', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20.306 19.498"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      data-name="log out - icon - gray"
      transform="translate(-467.003 -513.958)"
    >
      <g transform="translate(467.003 513.959)">
        <g>
          <path
            d="M486.885,523.346h-7.192V520.34a.811.811,0,0,0-.48-.732.876.876,0,0,0-.9.1l-5.5,4.224a.792.792,0,0,0,0,1.268l5.5,4.224a.894.894,0,0,0,.9.1.811.811,0,0,0,.48-.733v-3.006h7.192a1.219,1.219,0,1,0,0-2.437Z"
            transform="translate(-467.849 -514.815)"
          />
          <path
            d="M486,526.622a.86.86,0,0,0-1.119.406,8.556,8.556,0,0,1-9.481,4.623,8.06,8.06,0,0,1-.04-15.883,8.559,8.559,0,0,1,9.5,4.579.844.844,0,0,0,.69.479.861.861,0,0,0,.774-.339.785.785,0,0,0,.076-.813A10.27,10.27,0,0,0,475,514.183a9.672,9.672,0,0,0,.052,19.059,10.266,10.266,0,0,0,11.376-5.549A.8.8,0,0,0,486,526.622Z"
            transform="translate(-467.003 -513.959)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Exit;
